import { Controller } from 'stimulus'
import { haptics } from '~/common/helpers/haptics'
export default class extends Controller {
  static classes = ['selected']

  connect() {
    this.labels = this.element.querySelectorAll('label')
    this.icons = this.labels[0].querySelector('i.s-icon')
    this.selectOne(this.element.querySelector('input[type=radio]:checked'))
  }

  select(event) {
    this.unselectAll()
    this.selectOne(event.currentTarget)
    haptics.tick()
  }

  // Private

  unselectAll() {
    this.labels.forEach((label) => {
      label.classList.remove(...this.selectedClasses)
      const icon = label.querySelector('i.s-icon')
      if (icon) {
        icon.classList.remove('fas')
        icon.classList.add('far')
      }
    })
  }

  selectOne(radio) {
    if (!radio) return
    const selectedLabel = radio.closest('label')
    if (this.icons) {
      for (const label of this.labels) {
        label.classList.add(...this.selectedClasses)
        const icon = label.querySelector('i.s-icon')
        icon.classList.remove('far')
        icon.classList.add('fas')
        if (label === selectedLabel) break
      }
    } else {
      selectedLabel.classList.add(...this.selectedClasses)
    }
  }
}
